module.exports = __webpack_public_path__ + "static/Mixpanel-ae8071e1adebb1577153eaea839b750b.png";